import {SET_COMPANY_WELCOME} from 'actions/types';

export default (state = null, action) => {
    switch(action.type) {
        case SET_COMPANY_WELCOME: 
            return {...action.welcome};
        default:            
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/companyWelcome.js